import React, { useContext, useEffect, useState, useRef } from "react";
import Cards from "react-credit-cards-2";
import "react-credit-cards-2/dist/es/styles-compiled.css";
import styles from "./StepPayMethodForm.module.css";
import Text from "src/components/atoms/Text/Text";
import Button from "src/components/atoms/Button/Button";
import { CCol } from "@coreui/react";
import StepProgressBar from "../../StepProgressBar/StepProgressBar";
import { MP_CLIENT } from "src/constants";
import {
  initMercadoPago,
  getIdentificationTypes,
} from "@mercadopago/sdk-react";
import { createCardToken } from "@mercadopago/sdk-react/coreMethods";
import { AuthContext } from "src/contexts/AuthContext";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { paymentMethodFormSchema } from './schemas/PayMethodFormSchema';
import{ formatCardNumber, formatExpiryDate }  from './utils/formatingFunctions';

export default function StepPayMethodForm(props) {
  const {
    title,
    submitButton,
    step,
    leftArrow,
    onClick,
    leftArrowOnClick,
    btnText,
  } = props;

  const navigate = useNavigate();

  const { registerApiBody, setRegisterApiBody } = useContext(AuthContext);

  const [cardData, setCardData] = useState({});
  const [identificationTypes, setIdentificationTypes] = useState([]);
  const [disabledNextButton, setDisabledNextButton] = useState(false);
  const [generateTokenError, setGenerateTokenError] = useState(false);

  const handleInputChange = (e) => {
    let inputValue = e.target.value;
    if (e.target.name == "number"){
      inputValue = e.target.value.replace(/ /g, "");
    }
    if (e.target.name == "expiry") {
        inputValue = e.target.value.replace(/[ /]/g, "");
    }
    setCardData({
        ...cardData,
        [e.target.id]: inputValue,
    });
  };

  const handlefocusChange = (e) => {
    setCardData({
      ...cardData,
      focus: e.target.name,
    });
  };

  initMercadoPago(MP_CLIENT);


  useEffect(() => {
    async function fetchData() {
      const identificationTypesResponse = await getIdentificationTypes();
      setIdentificationTypes(identificationTypesResponse);
    }
    fetchData();
  }, []);


  const handleSubmitButtonClick = () => {
    formik.handleSubmit();
  };


  const getMercadoPagoToken = async () => {
    setGenerateTokenError(false);
    await createCardToken({
      cardNumber: cardData?.cardNumber,
      cardholderName: cardData?.cardholderName,
      cardExpirationMonth: moment(cardData?.cardExpiration, "MMYY").format(
        "MM"
      ),
      cardExpirationYear: moment(cardData?.cardExpiration, "MMYY").format(
        "YYYY"
      ),
      securityCode: cardData?.securityCode,
      identificationType: cardData?.identificationType,
      identificationNumber: cardData?.identificationNumber,
    })
      .then((res) => {
        setRegisterApiBody({
          ...registerApiBody,
          pg_card_token: res.id,
          card_holder_name: res.cardholder.name,
          card_last_four_digits: res.last_four_digits,
          card_expiration: moment(cardData?.cardExpiration, "MMYY").format(
            "MM/YY"
          ),
        });
      })
      .then(() => {
        navigate("/registro-confirmar");
      })
      .catch((err) =>{
        setGenerateTokenError(true);
        console.log("Error", err);
      });
  };

  const formik = useFormik({
      initialValues: {
          name: "",
          number: "",
          expiry: "",
          cvc: "",
          tipoDocumento: "",
          documento: ""
      },
      validationSchema: paymentMethodFormSchema,
      onSubmit: async (values) => {
        setDisabledNextButton(true);
        await getMercadoPagoToken();
        setDisabledNextButton(false);
      },
  });

  return (
      <>
          {leftArrowOnClick && (
              <div className={styles.arrowContainer}>
                  <Button inline icon={leftArrow} onClick={leftArrowOnClick} />
              </div>
          )}
          <Text color="light-grey" size="md">
              {step.text}
          </Text>
          <Text size="xl" weight="semiBold">
              {title}
          </Text>
          <StepProgressBar stepId={step.id} totalSteps={7} />
          <div className={styles.creditCardContainer}>
              <Cards
                  number={cardData?.cardNumber || ""}
                  expiry={cardData?.cardExpiration || ""}
                  cvc={cardData?.securityCode || ""}
                  name={cardData?.cardholderName || ""}
                  focused={cardData?.focus || ""}
                  placeholders={{
                      name: "Nombre titular",
                  }}
              />
          </div>
          <form onSubmit={formik.handleSubmit}>
              <div className={styles.inputContainer}>
                  <Text weight="regular" size="sm" margin="marginSm">
                      Número de tarjeta
                  </Text>
                  <input
                      id="cardNumber"
                      name="number"
                      placeholder=""
                      value={formatCardNumber(formik.values.number)}
                      onChange={(e) => {
                          handleInputChange(e);
                          e.target.value = formatCardNumber(e.target.value);
                          formik.handleChange(e);
                      }}
                      className={styles.input}
                      maxLength={19}
                      onFocus={(e) => handlefocusChange(e)}
                      onInput={(event) =>
                          (event.target.value = event.target.value.slice(
                              0,
                              event.target.maxLength
                          ))
                      }
                  />
                  {formik.touched.number && formik.errors.number && (
                      <div className={styles.erorText}>
                          {formik.errors.number}
                      </div>
                  )}
              </div>
              <div className={styles.cvcContainer}>
                  <div className={styles.inputContainerSm}>
                      <Text weight="regular" size="sm" margin="marginSm">
                          Vencimiento
                      </Text>
                      <input
                          id="cardExpiration"
                          name="expiry"
                          placeholder="MM/AA"
                          value={formik.values.expiry}
                          onChange={(e) => {
                              handleInputChange(e);
                              e.target.value = formatExpiryDate(e.target.value);
                              formik.handleChange(e);
                          }}
                          className={styles.input}
                          maxLength={7}
                          onFocus={(e) => handlefocusChange(e)}
                          onInput={(event) =>
                              (event.target.value = event.target.value.slice(
                                  0,
                                  event.target.maxLength
                              ))
                          }
                      />
                      {formik.touched.expiry && formik.errors.expiry && (
                          <div className={styles.erorText}>
                              {formik.errors.expiry}
                          </div>
                      )}
                  </div>
                  <div className={styles.inputContainerSm}>
                      <Text weight="regular" size="sm" margin="marginSm">
                          Código de seguridad
                      </Text>
                      <input
                          id="securityCode"
                          type="text"
                          inputMode="numeric"
                          name="cvc"
                          placeholder="CVV"
                          value={formik.values.cvc}
                          onChange={(e) => {
                              handleInputChange(e);
                              formik.handleChange(e);
                          }}
                          onFocus={(e) => handlefocusChange(e)}
                          className={styles.input}
                          maxLength={4}
                          onInput={
                            (event) =>
                                event.target.value = event.target.value
                                .replace(/[^0-9]/g, '')
                                .slice(0, event.target.maxLength)  
                          }
                      />
                      {formik.touched.cvc && formik.errors.cvc && (
                          <div className={styles.erorText}>
                              {formik.errors.cvc}
                          </div>
                      )}
                  </div>
              </div>
              <div className={styles.inputContainer}>
                  <Text weight="regular" size="sm" margin="marginSm">
                      Nombre del titular
                  </Text>
                  <input
                      id="cardholderName"
                      type="text"
                      name="name"
                      placeholder=""
                      value={formik.values.name}
                      onChange={(e) => {
                          handleInputChange(e);
                          formik.handleChange(e);
                      }}
                      className={styles.input}
                      onFocus={(e) => handlefocusChange(e)}
                  />
                  <Text
                      weight="medium"
                      size="xs"
                      color="light-grey"
                      margin="marginSm"
                  >
                      Como figura en la tarjeta
                  </Text>
                  {formik.touched.name && formik.errors.name && (
                      <div className={styles.erorText}>
                          {formik.errors.name}
                      </div>
                  )}
              </div>
              <div className={styles.dniInputContainer}>
                  <Text weight="regular" size="sm" margin="marginSm">
                      Tipo de Documento
                  </Text>
                  <select
                      id="identificationType"
                      className={styles.select}
                      aria-label=".form-select-lg example"
                      onChange={(e) => {
                          handleInputChange(e);
                          formik.handleChange(e);
                      }}
                      name="tipoDocumento"
                      value={formik.values.tipoDocumento}
                  >
                      <option id="" value="" disabled selected>
                          Seleccionar...
                      </option>
                      {identificationTypes?.map((item, i) => (
                          <option id={item.id} value={item.id} key={i}>
                              {item.name}
                          </option>
                      ))}
                  </select>
                  {formik.touched.tipoDocumento &&
                      formik.errors.tipoDocumento && (
                          <div className={styles.erorText}>
                              {formik.errors.tipoDocumento}
                          </div>
                      )}
              </div>
              <div className={styles.dniInputContainer}>
                  <Text weight="regular" size="sm" margin="marginSm">
                      Documento
                  </Text>
                  <input
                      id="identificationNumber"
                      type="number"
                      name="documento"
                      placeholder=""
                      value={formik.values.documento}
                      onChange={(e) => {
                          handleInputChange(e);
                          formik.handleChange(e);
                      }}
                      className={styles.input}
                  />
                  <Text
                      weight="medium"
                      size="xs"
                      color="light-grey"
                      margin="marginSm"
                  >
                      Sin puntos ni guiones
                  </Text>
                  {formik.touched.documento && formik.errors.documento && (
                      <div className={styles.erorText}>
                          {formik.errors.documento}
                      </div>
                  )}
              </div>
              <CCol className={styles.buttonContainer} md={4} xs={12}>
                  <Button
                      color={"dark"}
                      size={"lg"}
                      text={btnText || submitButton.text}
                      type="submit"
                      onClick={handleSubmitButtonClick}
                      disabled={disabledNextButton}
                  />
              </CCol>
              {generateTokenError && (
                  <div className={styles.alertError}>
                      <p class="mb-0">
                          Ha habido un error al procesar la tarjeta, por favor
                          inténtelo nuevamente.
                      </p>
                  </div>
              )}
          </form>
      </>
  );
}
